<div class="qkb-bot-style" v-html="style" style="display: none"></div>